module.exports = __webpack_public_path__ + "static/media/1012595.7320767f.jpg";